import React, { useState } from "react";
import { Link } from "react-router-dom";

interface MobileHeaderProps {
  className?: string;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ className }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // When opening menu, prevent body scrolling
    if (!menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };
  
  return (
    <header
      className={`w-full bg-white border-b border-gray-200 min-h-16 ${className || ""} relative z-50`}
    >
      <div className="flex flex-1 gap-10 justify-between items-center py-3 pr-2 pl-4 size-full max-w-[480px] mx-auto">
        <Link to="/dashboard" className="flex gap-3 items-center self-stretch my-auto w-[153px] transition-transform active:scale-95">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/65ac23b34fbf60a5e474b57ec6c3d7b207bc780a"
            className="object-contain shrink-0 self-stretch my-auto w-8 aspect-square"
            alt="App icon"
          />
          <img
            src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/ca5b77642a3d666ac7f94012feda2bec65abb580"
            className="object-contain shrink-0 self-stretch my-auto aspect-[4.5] w-[99px]"
            alt="App logo"
          />
        </Link>
        <div className="flex items-center self-stretch my-auto w-10">
          <button
            className="flex overflow-hidden justify-center items-center self-stretch px-2 my-auto w-10 h-10 bg-white rounded-lg hover:bg-gray-100 transition-all active:scale-95 active:bg-gray-200"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            onClick={toggleMenu}
            aria-expanded={menuOpen}
          >
            <div className="relative w-6 h-6">
              <span className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${menuOpen ? 'opacity-0' : 'opacity-100'}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 12H21" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 6H21" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 18H21" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <span className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${menuOpen ? 'opacity-100' : 'opacity-0'}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 6L18 18" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </div>
          </button>
        </div>
      </div>
      
      {/* Dropdown Menu */}
      <div 
        className={`absolute right-2 top-16 w-64 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-50 transition-all duration-300 transform origin-top-right ${menuOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0 pointer-events-none'}`}
      >
        <div className="py-1">
          <Link 
            to="/profile" 
            className="flex items-center px-4 py-3 hover:bg-gray-50 transition-colors"
            onClick={toggleMenu}
          >
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
              <span className="text-blue-700 font-medium">SJ</span>
            </div>
            <div>
              <div className="text-sm font-medium text-gray-900">Sarah Johnson</div>
              <div className="text-xs text-gray-500">View Profile</div>
            </div>
          </Link>
        </div>
          
          <div className="border-t border-gray-200">
            <Link 
              to="/dashboard" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Home
            </Link>
            <Link 
              to="/alerts" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              Alerts
            </Link>
            <Link 
              to="/usage" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              Usage
            </Link>
            <Link 
              to="/top-up" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Top Up
            </Link>
            <Link 
              to="/leak-detection" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Leak Detection
            </Link>
            <Link 
              to="/conservation" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
              </svg>
              Conservation Hub
            </Link>
            <Link 
              to="/conservation-tips" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
              Water Saving Tips
            </Link>
          </div>
          
          <div className="border-t border-gray-200">
            <Link 
              to="/settings" 
              className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center"
              onClick={toggleMenu}
            >
              <svg className="mr-3 h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Settings
            </Link>
            <button 
              className="block w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-gray-50 transition-colors flex items-center"
              onClick={() => {
                toggleMenu();
                alert('Logout functionality will be available soon');
              }}
            >
              <svg className="mr-3 h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Log out
            </button>
          </div>
        </div>
      
      {/* Overlay to close menu when clicking outside */}
      <div 
        className={`fixed inset-0 bg-black transition-opacity duration-300 ${menuOpen ? 'bg-opacity-25 z-40' : 'bg-opacity-0 pointer-events-none -z-10'}`} 
        onClick={toggleMenu}
        aria-hidden="true"
      ></div>
    </header>
  );
};
